import React, { createContext, useCallback, useContext, useRef } from 'react';
import {
    RouteState,
    RouteStateDispatch,
    RouteStateRef,
    RouteStateContextProviderProps,
} from '../schema/RouteStateContext.types';

const RouteStateContext = createContext<RouteStateRef | null>(null);
const RouteStateDispatchContext = createContext<RouteStateDispatch | null>(null);

export const useRouteStateRef = () => {
    const RouteStateRef = useContext(RouteStateContext);
    if (!RouteStateRef) {
        throw new Error('invoke useRouteStateRef inside RouteStateContextProvider');
    } else if (!RouteStateRef.current) {
        throw new Error('RouteState is invalid');
    }
    return RouteStateRef;
};

export const useRouteStateDispatch = () => {
    const dispatch = useContext(RouteStateDispatchContext);
    if (!dispatch) {
        throw new Error('invoke useRouteStateDispatch inside RouteStateContextProvider');
    }
    return dispatch;
};

export const RouteStateContextProvider: React.FC<RouteStateContextProviderProps> = ({
    children,
    initialRouteState = {},
}) => {
    const routeStateRef = useRef<RouteState>(initialRouteState);
    const dispatch = useCallback((newState?: RouteState) => {
        routeStateRef.current = newState ?? {};
    }, []);
    return (
        <RouteStateContext.Provider value={routeStateRef}>
            <RouteStateDispatchContext.Provider value={dispatch}>
                {children}
            </RouteStateDispatchContext.Provider>
        </RouteStateContext.Provider>
    );
};
